import { Col, Row, Tag } from 'antd';
import RenderPhotos from 'components/employees/profile/RenderPhotos';
import { EmployeeRowProps } from 'interfaces/employee.interfaces';
import { removeZOnHourtoDisplay } from 'libs/dateFormaterPetition';
import { usersPaths } from 'constants/routePaths';
import { Link } from 'react-router';

export const EmployeeRow = ({ todaysEmployeeSchedules }: EmployeeRowProps) => {
  return (
    <div id={`employee-row-${todaysEmployeeSchedules._id}`}>
      <Row align="middle">
        <Col xl={2}>
          <RenderPhotos
            employeeId={todaysEmployeeSchedules.employee.idEmployee}
            lastName={todaysEmployeeSchedules.employee.lastName}
            name={todaysEmployeeSchedules.employee.name}
            size="sm"
          />
        </Col>
        <Col xl={22}>
          <p className="employee-name">
            <Link
              className="dashboard-employee-link"
              data-cy={`dashboard-employee-link-${todaysEmployeeSchedules.employee._id}`}
              to={`${usersPaths.basePath}/${usersPaths.userDetail}/${todaysEmployeeSchedules.employee._id}`}
            >
              <b>{`${todaysEmployeeSchedules.employee.name} ${todaysEmployeeSchedules.employee.lastName ?? ''}`}</b>
            </Link>
          </p>
          <Row>
            {todaysEmployeeSchedules.schedules.map((schedule) => (
              <Col
                xl={6}
                className="employee-schedule"
                key={`employee-schedule-${schedule._id}`}
              >
                <Tag>
                  {removeZOnHourtoDisplay(schedule.from)} -{' '}
                  {removeZOnHourtoDisplay(schedule.to)}
                </Tag>
              </Col>
            ))}
          </Row>
          <span className="contract-type">
            {todaysEmployeeSchedules.contractType}
          </span>
        </Col>
      </Row>
    </div>
  );
};
